import React, { useMemo } from 'react';
import { ReplenishmentReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useReplenishmentInvoiceBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'replenishment-invoice-report-card';
const ReplenishmentInvoiceCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const { date, amount, isLoading } = useReplenishmentInvoiceBriefQuery();
  const childrenNode = useMemo(() => {
    if (!isSystem && (date || amount || isLoading)) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title="Most recent invoice"
          items={[
            {
              label: 'Date',
              value: date ? date : '',
            },
            {
              label: 'Amount',
              value: amount ? amount : '',
            },
          ]}
        />
      );
    }
    return null;
  }, [amount, date, isLoading, isSystem]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.ReplenishmentInvoice);

  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      testId={TEST_ID}
      url={ROUTES.REPLENISHMENT_INVOICE_REPORT}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <ReplenishmentReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Replenishment Invoice"
      description="Replenishment invoices fund payments
and reimbursements. Reconcile invoices
and view details"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default ReplenishmentInvoiceCard;
